import { ModalService, ModalServiceModule } from '@b2b/common/services';
import { ApiService } from '@b2b/common/services/api/types';
import { Customer, UpdateCustomerDto } from '@b2b/types/customer';
import angular, { IFilterService } from 'angular';
import { TODO } from '@b2b/types/core';

export class MergeCustomersModalService {
  static $inject = [
    '$filter',
    'ApiService',
    'ModalService',
    'CalendarService',
    'HelpersService',
    'UserPreferencesService',
  ];

  constructor(
    private $filter: IFilterService,
    private apiService: ApiService,
    private modalService: ModalService,
    private CalendarService: TODO,
    private HelpersService: TODO,
    private UserPreferencesService: TODO
  ) {}

  open(data: { customersDetails: Customer[] }) {
    return this.modalService.open<Customer>({
      size: 'full',
      component: 'acmeCustomersIndividualsModalsMerge',
      resolve: {
        MODAL_DATA: () => {
          return {
            customersDetails: this.normalizeCustomers(data.customersDetails),
          };
        },
      },
    });
  }

  mergeCustomers(payload: { baseId: number; duplicateIds: number[] }) {
    return this.apiService.customers.merge(payload);
  }

  updateCustomer(payload: Partial<UpdateCustomerDto>) {
    return this.apiService.customers.update(payload).then((response) => response.data);
  }

  fetchCustomerDetails(customerId: number) {
    return this.apiService.customers
      .detail({ customerId, includeAssociatedMemberships: true, includeMergeHistory: false })
      .then((response) => response.data);
  }

  /**
   * We need to make sure only primary addresses can be selected
   */
  private normalizeCustomers(customers: Customer[]) {
    return angular.copy(customers).map((customer) => {
      const address = customer.address.filter((item) => item.type === 'primary');
      const customerMemberships = customer.memberships || [];
      const memberships = customerMemberships
        .filter((item) => item.lastVersion)
        .map((item) => {
          item.membershipStartDateParsed = this.$filter('date')(
            this.CalendarService.parseDate(item.membershipStartDate),
            this.UserPreferencesService.getDateFormat('standardDate', 'dateFormat')
          );
          item.membershipJoinedDateParsed = this.$filter('date')(
            this.CalendarService.parseDate(item.membershipJoinedDate),
            this.HelpersService.dateFormats.longYear
          );
          item.membershipExpirationDateParsed = this.$filter('date')(
            this.CalendarService.parseDate(item.membershipExpirationDate),
            this.UserPreferencesService.getDateFormat('standardDate', 'dateFormat')
          );
          return item;
        });
      return { ...customer, address, memberships };
    });
  }
}

export const MergeCustomersModalServiceModule = angular
  .module('acme.view.application.customers.modals.merge.services', [
    'acme.common.service.api', 
    'acme.common.service.calendar',
    'acme.common.service.helpers',
    'acme.common.service.userPreferences',
    ModalServiceModule]
  )
  .service('MergeCustomersModalService', MergeCustomersModalService).name;
